var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 299 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 324.103,
    height: 194.526,
    viewBox: "0 0 324.103 194.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15315",
    d: "M324.451 577.7a1.268 1.268 0 0 1-.919-2.2l.087-.345-.035-.083a3.4 3.4 0 0 0-6.28.023c-1.027 2.474-2.335 4.952-2.657 7.568a10.072 10.072 0 0 0 .177 3.464 40.382 40.382 0 0 1-3.673-16.772 38.975 38.975 0 0 1 .242-4.348q.2-1.775.556-3.525a40.85 40.85 0 0 1 8.1-17.313 10.871 10.871 0 0 0 4.522-4.691 8.293 8.293 0 0 0 .754-2.266 10.233 10.233 0 0 1-.664-3.529c-.307-.465-.856-.7-1.191-1.151-1.666-2.259-3.962-1.865-5.16 1.205-2.56 1.292-2.585 3.435-1.014 5.5 1 1.311 1.137 3.085 2.014 4.489-.09.115-.184.227-.274.343a41.112 41.112 0 0 0-4.291 6.8 17.091 17.091 0 0 0-1.02-7.939c-.977-2.356-2.807-4.341-4.419-6.377a3.508 3.508 0 0 0-6.248 1.723l-.01.09q.359.2.7.43a1.72 1.72 0 0 1-.693 3.13l-.035.005a17.114 17.114 0 0 0 .451 2.558c-2.068 8 2.4 10.911 8.772 11.042.141.072.278.144.419.213a41.964 41.964 0 0 0-2.259 10.63 39.8 39.8 0 0 0 .029 6.427l-.011-.076a10.518 10.518 0 0 0-3.59-6.073c-2.763-2.27-6.667-3.106-9.647-4.93a1.974 1.974 0 0 0-3.023 1.92l.012.08a11.556 11.556 0 0 1 1.3.624q.359.2.7.43a1.72 1.72 0 0 1-.693 3.13l-.035.005-.072.011a17.129 17.129 0 0 0 3.15 4.933c1.293 6.982 6.847 7.644 12.788 5.611a41.952 41.952 0 0 0 2.818 8.227H324.2c.036-.112.069-.227.1-.339a11.44 11.44 0 0 1-2.786-.166c.747-.917 1.494-1.84 2.241-2.757a.623.623 0 0 0 .047-.054c.379-.469.761-.935 1.14-1.4a16.754 16.754 0 0 0-.491-4.268z",
    transform: "translate(-270.065 -392.531)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15316",
    d: "M825.815 577.7a1.268 1.268 0 0 0 .919-2.2l-.087-.345.034-.083a3.4 3.4 0 0 1 6.28.023c1.027 2.474 2.335 4.952 2.657 7.568a10.075 10.075 0 0 1-.177 3.464 40.382 40.382 0 0 0 3.673-16.772 38.982 38.982 0 0 0-.242-4.348q-.2-1.775-.556-3.525a40.85 40.85 0 0 0-8.1-17.313 10.872 10.872 0 0 1-4.521-4.691 8.291 8.291 0 0 1-.754-2.266 10.236 10.236 0 0 0 .664-3.529c.307-.465.856-.7 1.191-1.151 1.666-2.259 3.962-1.865 5.16 1.205 2.56 1.292 2.585 3.435 1.014 5.5-1 1.311-1.137 3.085-2.014 4.489.09.115.184.227.274.343a41.116 41.116 0 0 1 4.291 6.8 17.091 17.091 0 0 1 1.02-7.939c.977-2.356 2.807-4.341 4.419-6.377a3.508 3.508 0 0 1 6.248 1.723l.01.09q-.359.2-.7.43a1.72 1.72 0 0 0 .693 3.13l.035.005a17.114 17.114 0 0 1-.451 2.558c2.068 8-2.4 10.911-8.772 11.042-.141.072-.278.144-.419.213a41.967 41.967 0 0 1 2.259 10.63 39.812 39.812 0 0 1-.029 6.427l.011-.076a10.518 10.518 0 0 1 3.59-6.073c2.763-2.27 6.667-3.106 9.647-4.93a1.974 1.974 0 0 1 3.023 1.92l-.012.08a11.556 11.556 0 0 0-1.3.624q-.359.2-.7.43a1.72 1.72 0 0 0 .693 3.13l.035.005.072.011a17.127 17.127 0 0 1-3.15 4.933c-1.293 6.982-6.847 7.644-12.788 5.611a41.951 41.951 0 0 1-2.818 8.227h-10.069a8.684 8.684 0 0 1-.1-.339 11.438 11.438 0 0 0 2.786-.166c-.747-.917-1.494-1.84-2.241-2.757a.618.618 0 0 1-.047-.054c-.379-.469-.761-.935-1.14-1.4a16.752 16.752 0 0 1 .491-4.268z",
    transform: "translate(-561.152 -392.531)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15317",
    d: "M386.895 418.2h16.246c2.779-9.356.015-31.466 3.677-40.5 7.026-17.327 16-35.61 32.757-44.071a49.215 49.215 0 0 1 22.919-4.947c11 .1 22.317 3.058 32.674 6.973 4.237 1.6 8.435 3.355 12.617 5.15 15.754 6.77 31.337 14.143 48.279 16.136 21.438 2.52 46.644-7.072 52.5-27.732 4.469-15.818-3.579-32.239-12.02-46.366s-17.875-29.242-16.334-45.6c.005-.055.011-.115.022-.17.58-5.875 4.088-10.1 8.987-12.8h-21.335C567.6 239.532 576.43 253 584.373 266.3c8.441 14.121 16.489 30.548 12.02 46.366-5.855 20.655-54.34-3.557-75.779-6.082-6.054-.708 3.563 1.812-2.21 0-9.054-2.839-10.057 23.2-18.868 19.375-5.485-2.383-10.976-4.749-16.539-6.852-2.3-.873-4.657-1.691-7.037-2.449-.006 0-.006 0-.011-.006-15.986-5.062-33.469-7.033-48.24.286l-.3.148c-16.754 8.455-25.73 26.738-32.757 44.065-5.809 14.322-4.896 41.949-7.757 57.049z",
    transform: "translate(-320.929 -224.275)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 830",
    cx: 74.615,
    cy: 74.615,
    r: 74.615,
    transform: "translate(81.736 44.22)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15318",
    d: "M494.952 470.639c-73.825 1.7-75.443-33.377-75.443-75.095a75.656 75.656 0 0 1 151.313 0c0 41.717-34.153 75.095-75.87 75.095zm.213-148.669c-40.569 0-72.892 33.011-73.575 73.574-.635 37.729 39.445 84.809 73.575 73.575 18.3-20.157 70.049-41.868 73.575-73.575 4.483-40.32-33.005-73.574-73.575-73.574z",
    transform: "translate(-338.814 -276.709)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15319",
    d: "M529.7 479.089a8.3 8.3 0 0 1-6.639-3.321L502.7 448.626a8.3 8.3 0 0 1 13.28-9.959l13.32 17.756 34.2-51.307a8.3 8.3 0 1 1 13.812 9.208l-40.713 61.069a8.3 8.3 0 0 1-6.676 3.693z",
    transform: "translate(-383.528 -321.42)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15320",
    d: "M240.825 653.175a.536.536 0 0 0 .537.537h323.029a.537.537 0 0 0 0-1.075H241.362a.536.536 0 0 0-.537.537z",
    transform: "translate(-240.825 -459.187)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15321",
    d: "M443.891 397.423h-4.369l-2.078-16.853h6.448z",
    transform: "translate(-239.892 -208.703)",
    style: {
      fill: "#ffb6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15322",
    d: "M676.571 643.437h-13.436v-.17a5.23 5.23 0 0 1 5.229-5.229l2.454-1.862 4.579 1.862h1.173z",
    transform: "translate(-472.418 -450.159)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15323",
    d: "m394.588 352.736-4.036 1.674-8.376-14.771 5.957-2.47z",
    transform: "translate(-209.584 -184.902)",
    style: {
      fill: "#ffb6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15324",
    d: "m639.03 599.049-12.41 5.151-.065-.157a5.23 5.23 0 0 1 2.827-6.834l1.554-2.66 4.943-.034 1.083-.449z",
    transform: "translate(-452.137 -427.064)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15325",
    d: "m643.477 429.884-31.006 3.24-4.148 13.969-14.364 23.083s10.023 16.869 9.082 16.686.94 4.415 2.258 4.148 2.688 2.731 1.777 3.264 2.743 5.041 2.743 5.041l5.581-5.015c1.188-8.961-.247-16.936-5.361-23.529l16-17.275 3.034-1.259 2.409 64.1 8.909.146c2.458-12.645 3.693-24.026 1.772-32.146 0 0 .276-24.391 1.33-24.124s.16-2.911.16-2.911-.923-2.706.211-3.829.426-7.726.426-7.726c1.877-6.247 1.31-11.402-.813-15.863z",
    transform: "translate(-434.482 -337.03)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15326",
    d: "m639.826 306.334 8.572-2.221 4-5.519 9.5 1.168 2.023 7.527 6.765 3.927s-3.739 39.548-2.85 41.719 4.078 1.992 1.355 4.792-3.084 1.672-2.452 4.719 5.239 6.273 0 6.241-36.851-.484-35.948-4.1.889-2.7 2.251-4.961 2.279-1 1.82-4.342a39.15 39.15 0 0 1-.007-7.407c0-1.806 1.513-18.222 1.513-18.222z",
    transform: "translate(-454.672 -265.031)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 831",
    cx: 10.07,
    cy: 10.07,
    r: 10.07,
    transform: "translate(192.385 12.404)",
    style: {
      fill: "#ffb6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15327",
    d: "M665.761 252.279c.884.715.682 4.189 1.667 3.623s1.19-1.581 2.325-1.591a3.715 3.715 0 0 1 2.446 1.107c.121.109.236.224.347.337.1-.036.2-.068.309-.095a3.2 3.2 0 0 1 2.347.33 3.139 3.139 0 0 0-1.787.721c.217.243.436.487.667.712 1.929 1.89 5.883-.123 8.542-.577-2.214 2.418-1.778 3.768-1.227 7v.177c.113-.745 2.5-.708 2.107.281a12.708 12.708 0 0 1-1.84 2.7c3.252-2.253 5.878-5.359 6.458-9.111a5.514 5.514 0 0 0 .127-2.363 1.812 1.812 0 0 0-1.731-1.38 6.676 6.676 0 0 0-8.211-8.422 25.518 25.518 0 0 0-3.089 1.333 5.552 5.552 0 0 1-3.271.554 4.392 4.392 0 0 0-2.091-.3c-.793.238-1.135 1.076-1.453 1.885a3.2 3.2 0 0 1 1.489 1.123 3.127 3.127 0 0 0-1.924-.078.2.2 0 0 0-.034.009c-.717 1.291-.758 1.607-2.173 2.025z",
    transform: "translate(-473.858 -235.9)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15328",
    d: "M647.057 304.805c-5.158-.415-9.867 3.529-12.014 8.237s-2.288 10.049-2.392 15.222l-.324 16.081c-.048 2.38-.1 4.76-.214 7.137a34.894 34.894 0 0 1-.869 6.87c-1.052 4.139-3.365 7.827-5.644 11.438a154.662 154.662 0 0 0 17.774 4.245c3-9.7 6.03-19.672 5.293-29.794-.39-5.357-1.831-10.586-2.378-15.929-.776-7.567.252-15.189 1.278-22.726",
    transform: "translate(-451.834 -268.421)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15329",
    d: "M684.633 306.845c5.109.821 8.747 5.771 9.714 10.854s-.164 10.3-1.291 15.354l-3.5 15.7c-.518 2.323-1.037 4.646-1.486 6.984-.437 2.271 1.392 5.183 1.413 7.495.039 4.27-.791 7.787.566 11.836a154.655 154.655 0 0 1-18.273-.1c-.609-10.131-1.186-20.541 1.934-30.2 1.651-5.111 4.292-9.849 6.093-14.909 2.55-7.166 3.362-14.815 4.155-22.38",
    transform: "translate(-476.889 -269.556)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15330",
    d: "M707.905 434.333a2.926 2.926 0 0 1 1.013-3.954 2.806 2.806 0 0 1 .418-.2L708.685 408l7.057-1.8-2.691 25.842a2.918 2.918 0 0 1-1.278 3.326 2.793 2.793 0 0 1-3.829-.968z",
    transform: "translate(-496.757 -324.042)",
    style: {
      fill: "#ffb6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15331",
    d: "M705.562 325.2s4.926-4.166 9.071 4.163 1.829 27.357 1.245 28.373-.94-.4-.62 2.308c.26 2.2-1.285 1.926-.731 2.4 1.462 1.239-2.631 1.38-.529 2.471s-7.306 1.3-7.306 1.3-1.138-.813-.348-3.877c.444-1.721 1.555-2.351.37-3.147s1.224-3.259 1.226-3.8-3.758-12.357-3.758-12.357z",
    transform: "translate(-494.927 -279.051)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15332",
    d: "M582.179 459.357a8.3 8.3 0 0 1-6.639-3.321l-20.356-27.142a8.3 8.3 0 1 1 13.28-9.959l13.318 17.756 34.2-51.307a8.3 8.3 0 1 1 13.812 9.208l-40.713 61.069a8.3 8.3 0 0 1-6.676 3.694z",
    transform: "translate(-412.307 -310.599)",
    style: {
      fill: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15333",
    d: "M643.724 425.328a2.926 2.926 0 0 0-.793-4 2.807 2.807 0 0 0-.406-.225l1.876-22.111-6.947-2.183 1.259 25.951a2.918 2.918 0 0 0 1.092 3.391 2.793 2.793 0 0 0 3.877-.755z",
    transform: "translate(-458.335 -318.889)",
    style: {
      fill: "#ffb6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15334",
    d: "M644.963 316.845s-4.688-4.432-9.287 3.656-3.338 27.214-2.811 28.26.96-.347.492 2.339c-.381 2.184 1.177 1.994.6 2.433-1.528 1.156 2.551 1.523.392 2.5s7.223 1.7 7.223 1.7 1.181-.749.561-3.852c-.348-1.743-1.423-2.433-.2-3.163s-1.042-3.322-1.014-3.861 4.435-12.131 4.435-12.131z",
    transform: "translate(-455.509 -274.375)",
    style: {
      fill: "#3f3d56"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.c3c21d4e214d571d04be9d7d046cc212.svg";
export { ForwardRef as ReactComponent };